import { render, staticRenderFns } from "./ImportBCModal.vue?vue&type=template&id=58204096&scoped=true&"
import script from "./ImportBCModal.vue?vue&type=script&lang=js&"
export * from "./ImportBCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58204096",
  null
  
)

export default component.exports